import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

import { environment } from '../../environments/environment';
import { EnvironmentDeploymentType } from 'src/environments/IEnvironment';
import { AuthService } from '../share/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ShellService {

  private _serverContext: IServerContext;

  private _shellContext: IShellContext;

  private searchTermEntered(st: string): void {
    alert(`search for: ${st}`);
  }

  get shellContext() {
    return this._shellContext;
  }

  /**
   *
   * @returns
   */
  isOneTime(): boolean {
    const path = this.location.path(true);
    return path.toUpperCase().startsWith('/OT/');
  }

  showChrome: boolean = true;

  /// constructor
  constructor(private router: Router, private location: Location, private authService: AuthService) {
    this._serverContext = ServerContexts.serverContext();

    this._shellContext = {
      ...this._serverContext,

      title: `${environment.title}`,
      envName: environment.name,
      displayTitle: `${environment.title} ${environment.production ? '' : `(${environment.name})`}`,
      searchTermEntered: this.searchTermEntered,

      goBack: () => this.location.back(),
      goHome: () => this.router.navigate(['/'])
    };
  }

  /**
   *
   */
  logout() {
    this.authService.logout();
    this.router.navigate(['/']);
  }

  /**
   *
   * @returns
   */
  deploymentContext(): IDeploymentContext {
    return {
      customer: environment.deploymentType == 'customer',
      internal: environment.deploymentType == 'internal',
      external: environment.deploymentType == 'external',
      chauffeur: environment.deploymentType == 'chauffeur'
    };
  }
}

/// all shell stuff
export interface IShellContext extends IServerContext {
  title: string,
  envName: string,
  displayTitle: string,
  searchTermEntered: (st: string) => void,
  goBack: () => void,
  goHome: () => void
}

interface IServerContext {
  navLinks: INavSection[],
  versionString: string,
}

interface INavBase {
  name: string;
  canViewInDemoEnv?: boolean;
}

export interface INavSection extends INavBase {
  menuName: string;

  pages: INavPage[];
}

export interface INavPage extends INavBase {
  routerLink?: string;
  href?: string;
}

/**
 *
 */
export interface IDeploymentContext {
  customer: boolean;
  internal: boolean;
  external: boolean;
  chauffeur: boolean
}

/**
 *
 */
class ServerContexts {

  /**
   * for external customers
   * @returns
   */
  public static customer(): IServerContext {
    const ret: IServerContext = {
      versionString: 'v1234',
      navLinks: [
        {
          name: 'Reservations', canViewInDemoEnv: true, menuName: 'main', pages: [
            { name: 'Manifest', routerLink: '/reservations/manifest', canViewInDemoEnv: false }
          ]
        }
      ]
    };
    return ret;
  }

  /**
   * external users
   * @returns
   */
  public static external(): IServerContext {
    const ret: IServerContext = {
      versionString: 'v1234',
      navLinks: [
      ]
    };
    return ret;
  }

  /**
   * for internal ECLS employees
   */
  public static internal(): IServerContext {
    const ret: IServerContext = {
      versionString: 'v1234',
      navLinks: [
        {
          name: 'Accounting', canViewInDemoEnv: true, menuName: 'main', pages: [
            { name: 'Vendor Payout', routerLink: '/accounting/vendor-payout', canViewInDemoEnv: false },
          ]
        },
        {
          name: 'Affiliates', canViewInDemoEnv: true, menuName: 'main', pages: []
        },
        {
          name: 'Chauffeurs', canViewInDemoEnv: true, menuName: 'main', pages: [
            { name: 'Emails', routerLink: '/chauffeurs/emails', canViewInDemoEnv: false },
            { name: 'Payroll', routerLink: '/chauffeurs/payroll', canViewInDemoEnv: false },
            { name: 'HR', routerLink: '/chauffeurs/hr', canViewInDemoEnv: false }
            //{ name: 'Chauffeur Portal Manager', routerLink: '/chauffeurs/chauffeur-portal-manager', canViewInDemoEnv: false }
          ]
        },
        {
          name: 'Costing', canViewInDemoEnv: true, menuName: 'main', pages: [
            { name: 'Affiliate Payout', routerLink: '/costing/affiliate-payout', canViewInDemoEnv: false },
          ]
        },
        {
          name: 'Reservations', canViewInDemoEnv: true, menuName: 'main', pages: [
            { name: 'Request Vehicle', routerLink: '/reservations/request-vehicle', canViewInDemoEnv: false },
            { name: 'Customer Manifest', routerLink: '/reservations/customer-manifest', canViewInDemoEnv: false },
            { name: 'Rates', routerLink: '/reservations/rates', canViewInDemoEnv: false }
            //{ name: 'Tour Management', routerLink: '/reservations/tour-management', canViewInDemoEnv: false },
          ]
        },
        {
          name: 'Reporting', canViewInDemoEnv: false, menuName: 'main', pages: [
            { name: 'Reports', routerLink: '/reports', canViewInDemoEnv: false },
            { name: 'Trend Reports', routerLink: '/trend-reports-dashboard', canViewInDemoEnv: false },
            { name: 'Salesman Reports', routerLink: '/salesman-reports-dashboard', canViewInDemoEnv: false },
          ]
        },
        {
          name: 'Dashboards', canViewInDemoEnv: true, menuName: 'contactCenter', pages: [
            { name: 'Alert Analysis', routerLink: '/dashboards/avaya-dashboards/alert-analyzes/alert-analyzes', canViewInDemoEnv: true }
          ]
        },
        {
          name: 'Boards', canViewInDemoEnv: true, menuName: 'contactCenter', pages: [
            { name: 'NJ Call Status Board', routerLink: '/dashboards/call-board/skillsetRollup/NJ', canViewInDemoEnv: true },
            { name: 'LA Call Status Board', routerLink: '/dashboards/call-board/skillsetRollup/LA', canViewInDemoEnv: true },
            { name: 'Email Status Board', routerLink: '/dashboards/call-board/skillsetRollup/Email', canViewInDemoEnv: true },
            { name: 'Agents Status Board', routerLink: '/dashboards/agent-board', canViewInDemoEnv: true }
          ]
        }
      ]
    };
    return ret;
  }

  /**
   *
   * @returns
   */
  public static serverContext(): IServerContext {
    const ret = environment.deploymentType == 'internal' ? ServerContexts.internal()
      : environment.deploymentType == 'customer' ? ServerContexts.customer()
        : { navLinks: [], versionString: 'unknown' };
    return ret;
  }
}
